import React from 'react';
import { Container } from './styles';

const Card = (props) => <Container {...props}>{props.children}</Container>;

export default Card;
